import React from 'react'
import MovieContainer from './components/MovieContainer'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'

const App = ()=>{
  return (
    <div>
         <MovieContainer/>
    </div>
  )
}

export default App